/* eslint-disable react/jsx-props-no-spreading */
import { components } from "react-select";
import { ReactComponent as ArrowDownIcon } from "assets/icons/Arrow-Down.svg";

export default function DropdownIndicator(props) {
  return (
    <components.DropdownIndicator {...props}>
      <ArrowDownIcon />
    </components.DropdownIndicator>
  );
}
